import { useLayoutEffect } from 'react';
import { useDataColorScheme } from '../../../../hooks/useDataColorScheme';
import { useGlobalAppStateStore } from '../../../../stores/app/GlobalAppStateStore';
import { InterfaceClient } from '../../../../stores/InterfaceStore/types';

const DATA_COLOR_SCHEME_ATTR = 'data-color-scheme';

// Matrix root layout owns <body data-color-scheme>; overlay/portaled components read the
// scheme from body to render with correct styles. Builder/preview scope the attr to inner
// containers, so writing body there leaks the scheme onto platform (property panels,
// hierarchy). Gate on the UA_MATRIX client, not RUNNER mode — a runner can also be embedded
// inside platform, where body must stay untouched.
export function useSyncBodyColorScheme() {
  const colorScheme = useDataColorScheme();
  const client = useGlobalAppStateStore().hooks.useClient();

  useLayoutEffect(() => {
    if (client !== InterfaceClient.UA_MATRIX) return;
    if (typeof document === 'undefined' || !colorScheme) return;
    document.body.setAttribute(DATA_COLOR_SCHEME_ATTR, colorScheme);
  }, [colorScheme, client]);
}
